module.exports = __webpack_public_path__ + "3e8156c8a1218cdd6a9064945b371767.MP3";